/** @jsxImportSource @gasman/smush */

import './counter.css';
import angleLeftImage from '../icons/angle-left.svg';
import angleRightImage from '../icons/angle-right.svg';

import { Component } from '@gasman/smush';

let counterId = 0;

class Counter extends Component {
    constructor(opts) {
        /*
        recognised opts:
        label
        property
        setter
        changeEvent
        min
        max
        */
        super();
        this.property = opts.property;
        this.setter = opts.setter;
        this.changeEvent = opts.changeEvent;
        this.min = 'min' in opts ? opts.min : null;
        this.max = 'max' in opts ? opts.max : null;
        this.label = opts.label;

        this.receiver = null;
        this.undoBuffer = null;
        this.undoPath = null;

        this.decrement = this.decrement.bind(this);
        this.increment = this.increment.bind(this);

        let changeAction = () => {
            if (this.receiver) {
                this.writeValue(parseInt(this.input.value));
            }
        };
        this.htmlId = 'counter-' + counterId++;
        this.input = (
            <input type="number" id={this.htmlId} onchange={changeAction} />
        );
        if (this.min !== null) this.input.min = this.min;
        if (this.max !== null) this.input.max = this.max;
    }

    decrement() {
        if (this.receiver) {
            var value = this.receiver[this.property];
            var newValue = value - 1;
            if (this.min !== null && newValue < this.min) {
                /* out of range */
            } else {
                this.writeValue(newValue);
            }
        }
    }

    increment() {
        if (this.receiver) {
            var value = this.receiver[this.property];
            var newValue = value + 1;
            if (this.max !== null && newValue > this.max) {
                /* out of range */
            } else {
                this.writeValue(newValue);
            }
        }
    }

    writeValue(newValue) {
        let oldValue = this.receiver[this.property];
        if (oldValue == newValue) return;

        if (this.setter) {
            this.receiver[this.setter](newValue);
        } else {
            this.receiver[this.property] = newValue;
        }

        if (this.undoBuffer) {
            this.undoBuffer.push({
                path: this.undoPath,
                forward: newValue,
                reverse: oldValue,
            });
        }
    }

    render(container) {
        container.appendChild(
            <div class="counter">
                <label for={this.htmlId}>{this.label}:</label>
                <button onclick={this.decrement} tabindex="-1">
                    <img src={angleLeftImage} alt="-" />
                </button>
                {this.input}
                <button onclick={this.increment} tabindex="-1">
                    <img src={angleRightImage} alt="+" />
                </button>
            </div>,
        );
    }

    bind(receiver, opts) {
        opts = opts || {};
        this.unbind();
        this.receiver = receiver;
        this.receiver.on(this.changeEvent, this.onChange);
        this.renderValue(this.receiver[this.property]);

        if (opts.undoBuffer) {
            this.undoBuffer = opts.undoBuffer;
            this.undoPath = [...opts.undoPath, this.property];
        }
    }

    unbind() {
        if (this.receiver) {
            this.receiver.removeListener(this.changeEvent, this.onChange);
            this.receiver = null;
            this.undoBuffer = null;
            this.undoPath = null;
        }
    }

    onChange = (newValue) => {
        this.renderValue(newValue);
    };

    renderValue(value) {
        this.input.value = value;
    }

    static forField(field, opts) {
        return new Counter({
            label: field.label,
            property: field.name,
            changeEvent: field.eventName,
            min: field.min,
            max: field.max,
            ...opts,
        });
    }
}

export { Counter };
